// The chat's stall watchdog: a timer every agent event re-arms. When it
// fires, the run has been quiet for the whole threshold, and the stall it
// reports began at the last event, not at the moment of firing, so the
// indicator that counts from `quietSince` shows the true silence. It only
// informs; ending or retrying the run is the stream runtime's and the
// person's business.
export function createStallWatchdog({
    thresholdMs,
    onStall,
    now = () => Date.now(),
    schedule = (fn, ms) => setTimeout(fn, ms),
    cancel = (timer) => clearTimeout(timer),
}) {
    let timer = null;
    let stopped = false;
    const disarm = () => {
        if (timer == null) return;
        cancel(timer);
        timer = null;
    };
    const arm = () => {
        if (stopped) return;
        disarm();
        const quietSince = now();
        timer = schedule(() => {
            timer = null;
            if (!stopped) onStall(quietSince);
        }, thresholdMs);
    };
    // The run is over: nothing fires, and a late event cannot re-arm it.
    const stop = () => {
        stopped = true;
        disarm();
    };
    return { arm, disarm, stop, armed: () => timer != null };
}
